import { render, staticRenderFns } from "./PollManager.vue?vue&type=template&id=97e48e5c"
import script from "./PollManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollManager.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports